import React, { useState } from "react";
import "./LearningJourney.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabsUnstyled from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./PowerbiLearningJourney.css";

const PowerbiLearningJourney = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="learning-Journey-container">
        <h2>Power BI Learning Journey</h2>
        <div className="lj-menu-wrapper">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  role="tablist"
                  onChange={handleChange}
                  className="main-list"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                >
                  <Tab role="tab" label="Overall" value="1" className="list1 item" />
                  <Tab role="tab" label="Aware" value="2" className="list2 item" />
                  <Tab role="tab" label="Equipped" value="3" className="list3 item" />
                  <Tab role="tab" label="Competent" value="4" className="list4 item" />
                  {/* <Tab role="tab" label="Expert" value="5" className='list5 item'/> */}
                </TabList>
              </Box>
              <div className="lj-box">
                <TabPanel role="tabpanel" value="1">
                  <div className="lj-images">
                    <img
                      src="images/PowerBi/PowerBI-Overall.png"
                      alt="overall-img"
                      className="lj-images"
                    />
                    {/* <h2 className='coming-soon'>coming Soon</h2> */}
                  </div>
                </TabPanel>
                <TabPanel role="tabpanel" value="2">
                  <div className="lj-images">
                    <img
                      src="images/PowerBi/PowerBI-Aware.jpg"
                      alt="aware-img"
                      className="lj-images"
                      onClick={() =>
                        window.open(
                          "https://connectedlearning.accenture.com/topics/power-bi-aware"
                        )
                      }
                    />
                    {/* <div className='LJ-link-Wrapp' id='powerBI'>
                  <img src='images/PowerBi/LearningJourney/Aware/Power-BI-aware.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='powerBI-Aware'>
                    <p className='link1'>
                      <a href="https://share.percipio.com/cd/BpjyrTr9U" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://share.percipio.com/cd/5sc7QPFiL" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://share.percipio.com/cd/U0Bd8WJ7y" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://share.percipio.com/cd/c_k9QnqcO" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://share.percipio.com/cd/jSRw2Locr" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://share.percipio.com/cd/avZuD8BRW" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://share.percipio.com/cd/sphGKSgwW" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://share.percipio.com/cd/IPiuYjgiE" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="accenture.percipio.com/courses/2957c545-fd86-4b7f-b296-4ca6495d3db7/videos/5dc8e598-d06c-45ed-ae24-344cd59b9e92" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/2957c545-fd86-4b7f-b296-4ca6495d3db7/videos/011f18a6-4627-457d-ab4d-b1d53958a950" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/2957c545-fd86-4b7f-b296-4ca6495d3db7/videos/cead41c9-9df9-4c8e-944c-5d2dfeaa9d99" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/courses/2957c545-fd86-4b7f-b296-4ca6495d3db7/videos/d1a1a110-85b6-4a04-8c11-a306e053ab70" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/courses/2957c545-fd86-4b7f-b296-4ca6495d3db7/videos/3481485a-5ad4-43e7-bab5-1085d60c5c3e" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://share.percipio.com/cd/vYthXar2d" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://share.percipio.com/cd/mCIVp_pid" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/15.png'/></a>
                    </p>
                    <p className='link16'>
                      <a href="https://share.percipio.com/cd/BJWO4a4RR" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/16.png'/></a>
                    </p>
                    <p className='link17'>
                      <a href="https://share.percipio.com/cd/D5KFKZuyV" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/17.png'/></a>
                    </p>
                    <p className='link18'>
                      <a href="https://share.percipio.com/cd/jDbLKoOke" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/18.png'/></a>
                    </p>
                    <p className='link19'>
                      <a href="https://share.percipio.com/cd/97Pn5Ckgw" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/19.png'/></a>
                    </p>
                    <p className='link20'>
                      <a href="https://share.percipio.com/cd/11xgsmefG" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/20.png'/></a>
                    </p>
                    <p className='link21'>
                      <a href="https://share.percipio.com/cd/gqFi_M0J-" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/21.png'/></a>
                    </p>
                    <p className='link22'>
                      <a href="https://share.percipio.com/cd/2u3UAcRH77" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/22.png'/></a>
                    </p>
                    <p className='link23'>
                      <a href="https://share.percipio.com/cd/x2bSEmscP" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/23.png'/></a>
                    </p>
                    <p className='link24'>
                      <a href="https://share.percipio.com/cd/zyGXMHoOQ" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/24.png'/></a>
                    </p>
                    <p className='link25'>
                      <a href="https://share.percipio.com/cd/gyLZBlBO7" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/25.png'/></a>
                    </p>
                    <p className='link26'>
                      <a href="https://share.percipio.com/cd/osf-esk2M" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/26.png'/></a>
                    </p>
                    <p className='link27'>
                      <a href="https://share.percipio.com/cd/3wIVoRVsM" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/27.png'/></a>
                    </p>
                    <p className='link28'>
                      <a href="https://share.percipio.com/cd/DSVbVC5Vz" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/28.png'/></a>
                    </p>
                    <p className='link29'>
                      <a href="https://share.percipio.com/cd/r7jPBkVc6" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/29.png'/></a>
                    </p>
                    <p className='link30'>
                      <a href="https://share.percipio.com/cd/8YWvqT7g_" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/30.png'/></a>
                    </p>
                    <p className='link31'>
                      <a href="https://share.percipio.com/cd/0MnZhx9sy" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/31.png'/></a>
                    </p>
                    <p className='link32'>
                      <a href="https://share.percipio.com/cd/pdXsgcJGL" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/32.png'/></a>
                    </p>
                    <p className='link33'>
                      <a href="https://share.percipio.com/cd/nK5Gqih2P" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/33.png'/></a>
                    </p>
                    <p className='link34'>
                      <a href="https://share.percipio.com/cd/BZTvsIAZV" target="_blank"><img src='images/PowerBi/LearningJourney/Aware/34.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
                  </div>
                </TabPanel>
                <TabPanel role="tabpanel" value="3">
                  <div className="lj-images">
                    <img
                      src="images/PowerBi/PowerBI-Equipped.jpg"
                      alt="equipped-img"
                      className="lj-images"
                      onClick={() =>
                        window.open(
                          "https://connectedlearning.accenture.com/topics/power-bi-equipped"
                        )
                      }
                    />
                    {/* <div className='LJ-link-Wrapp' id='powerBI'>
                  <img src='images/PowerBi/LearningJourney/Equipped/Power-BI-Equipped.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='powerBI-Equipped'>
                    <p className='link1'>
                      <a href="https://share.percipio.com/cd/kri9IiZBs" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://share.percipio.com/cd/hYXR14CGI" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://share.percipio.com/cd/94GUb1Zi1k" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://share.percipio.com/cd/2IsRLnSGK" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://share.percipio.com/cd/9x7dh7Xti" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://share.percipio.com/cd/hRtDjdrrh" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://share.percipio.com/cd/nJ3pLdxCn" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://share.percipio.com/cd/rp3cXzhEn" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://share.percipio.com/cd/UaL2V180j" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://share.percipio.com/cd/IBK_bTyaS" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://share.percipio.com/cd/mZ-sBmGLx" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://share.percipio.com/cd/yzFcO9t03" target="_blank"><img src='images/PowerBi/LearningJourney/Equipped/12.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
                  </div>
                </TabPanel>
                <TabPanel role="tabpanel" value="4">
                  <div className="lj-images">
                    <img
                      src="images/PowerBi/PowerBI-Competent.jpg"
                      alt="competent-img"
                      className="lj-images"
                      onClick={() =>
                        window.open(
                          "https://connectedlearning.accenture.com/topics/power-bi-competent-business-justification"
                        )
                      }
                    />
                    {/* <div className='LJ-link-Wrapp' id='powerBI'>
                  <img src='images/PowerBi/LearningJourney/Competent/Power-BI-Competent.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='powerBI-Competent'>
                    <p className='link1'>
                      <a href="https://share.percipio.com/cd/AgBwmvXeJ" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://share.percipio.com/cd/lCzWCvNtM" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://share.percipio.com/cd/iCeHczkHN" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://share.percipio.com/cd/2iyqW_PRZ" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://share.percipio.com/cd/7jkBzXPgy" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://share.percipio.com/cd/iVuQ3ahSf" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://share.percipio.com/cd/X7V6cTGMG" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://share.percipio.com/cd/5lr9tdpxp" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://share.percipio.com/cd/njztiwCwA" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://learn.microsoft.com/en-us/training/modules/optimize-model-power-bi/" target="_blank"><img src='images/PowerBi/LearningJourney/Competent/10.png'/></a>
                    </p>
                  </div>
                  </div>
                </div> */}
                  </div>
                </TabPanel>
                {/* <TabPanel role="tabpanel" value="5" >
          <div className='lj-images'>
                <h2 className='coming-soon'>coming Soon</h2>
            </div>
          </TabPanel> */}
              </div>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};
export default PowerbiLearningJourney;
